module.exports = __webpack_public_path__ + "img/wlt-logo.9485cdd2.jpg";